import { useEffect } from 'react'
import { useRouter, useLocalSearchParams, type Href } from 'expo-router'
import { IMPERSONATION_HANDLER_PATH } from '../../src/zportiAdmin/constants/impersonationRoute.constants'

function buildImpersonateHrefFromParams(
  params: Record<string, string | string[] | undefined>,
): Href {
  const q = new URLSearchParams()
  for (const [key, raw] of Object.entries(params)) {
    if (raw === undefined) continue
    const first = Array.isArray(raw) ? raw[0] : raw
    if (typeof first === 'string' && first.length > 0) {
      q.set(key, first)
    }
  }
  const s = q.toString()
  return (s ? `${IMPERSONATION_HANDLER_PATH}?${s}` : IMPERSONATION_HANDLER_PATH) as Href
}

/**
 * Legacy `/app/admin-impersonate` — forwards query to `/app/impersonate` (same handler).
 */
export default function LegacyAdminImpersonateRedirect() {
  const router = useRouter()
  const params = useLocalSearchParams()

  useEffect(() => {
    router.replace(buildImpersonateHrefFromParams(params))
  }, [router, params])

  return null
}
